import { h } from "preact";
import { useEffect, useRef } from "preact/hooks";
import { toCanvas } from "qrcode";

export function QRCode(props: { data: string, width?: number, height?: number, style?: string, scale?: number, margin?: number }) {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        if (props.data) {
            canvasRef.current!.style.display = "block";
            toCanvas(canvasRef.current, props.data, { scale: props.scale, margin: props.margin });
        }
        else {
            canvasRef.current!.style.display = "none";
        }
    }, [props.data, props.scale, props.margin]);

    return <canvas style={props.style} ref={canvasRef} width={props.width} height={props.height}/>;
}
